import React from 'react';

const MENU_CATEGORIES = [
  {
    title: "Entradas (Starters)",
    items: [
      { name: "Guacamole & Chips", desc: "Fresh avocados, lime, cilantro, house-made chips.", price: "$10" },
      { name: "Queso Fundido", desc: "Melted Oaxaca cheese, chorizo, warm flour tortillas.", price: "$12" },
      { name: "Ceviche de Pescado", desc: "Citrus-cured white fish, pico de gallo, avocado.", price: "$15" },
      { name: "Elotes Callejeros", desc: "Grilled street corn, mayo, cotija cheese, chili powder.", price: "$8" }
    ]
  },
  {
    title: "Platos Principales (Mains)",
    items: [
      { name: "Tacos Al Pastor", desc: "Marinated pork, pineapple, cilantro, onions (3 per order).", price: "$14" },
      { name: "Carne Asada", desc: "Grilled steak, guacamole, pico de gallo, tortillas.", price: "$24" },
      { name: "Enchiladas Verdes", desc: "Chicken filled, tomatillo sauce, crema, queso fresco.", price: "$18" },
      { name: "Fajitas de Pollo", desc: "Sizzling chicken, bell peppers, onions, served with rice & beans.", price: "$20" },
      { name: "Chile Relleno", desc: "Poblano pepper stuffed with cheese, battered and fried, ranchero sauce.", price: "$17" }
    ]
  },
  {
    title: "Bebidas (Drinks)",
    items: [
      { name: "Classic Margarita", desc: "Tequila blanco, fresh lime juice, agave.", price: "$12" },
      { name: "Paloma", desc: "Tequila, fresh grapefruit soda, lime, salt rim.", price: "$13" },
      { name: "Agua de Jamaica", desc: "Refreshing traditional hibiscus sweet tea.", price: "$5" },
      { name: "Horchata", desc: "Sweet rice milk beverage with cinnamon and vanilla.", price: "$5" }
    ]
  },
  {
    title: "Postres (Desserts)",
    items: [
      { name: "Churros con Chocolate", desc: "Crispy fried dough, cinnamon sugar, chocolate dipping sauce.", price: "$9" },
      { name: "Flan Tradicional", desc: "Classic vanilla custard with caramel sauce.", price: "$8" },
      { name: "Tres Leches Cake", desc: "Sponge cake soaked in three kinds of milk.", price: "$10" }
    ]
  }
];

const Menu = () => {
  return (
    <div className="px-8 md:px-16 py-20 max-w-4xl mx-auto w-full">
      <div className="text-center mb-16">
        <h1 className="text-6xl text-olive mb-4">NUESTRO MENÚ</h1>
        <p className="text-olive/80 max-w-xl mx-auto">
          Discover the vibrant tastes of Mexico. Our dishes are prepared daily using traditional recipes passed down through generations.
        </p>
      </div>

      <div className="space-y-16">
        {MENU_CATEGORIES.map((category, catIdx) => (
          <div key={catIdx}>
            <h2 className="text-4xl text-rust mb-8 border-b-2 border-rust/20 pb-2 inline-block">
              {category.title}
            </h2>
            <div className="grid md:grid-cols-2 gap-x-12 gap-y-8">
              {category.items.map((item, idx) => (
                <div key={idx} className="flex flex-col justify-between border-b border-olive/10 pb-4 h-full">
                  <div className="flex justify-between items-start mb-2">
                    <h3 className="text-2xl font-display text-olive tracking-wide pr-4">{item.name}</h3>
                    <span className="text-xl font-bold text-rust">{item.price}</span>
                  </div>
                  <p className="text-olive/70 text-sm leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Menu;